import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import Input from 'components/Input'
import Button from 'components/Button'
import BasePureComponent from 'utils/BasePureComponent'
import AddItemModal from 'components/AddItemModal'

import Select from 'components/Select'

import {
  nextStep,
  updateId,
  updateDatasetValue
} from 'scenes/ClientDetail/components/AddVehicleModal/actions'
import { vehiclesFetched } from 'scenes/ClientDetail/actions'
import { VEHICLE_DATASET } from 'scenes/ClientDetail/components/AddVehicleModal/constants'

import request from 'utils/request'
import {
  MAKERS_URL,
  BRANDS_URL,
  MODELS_URL,
  VEHICLES_LIST_URL,
  CLIENT_VEHICLES_URL,
  VEHICLE_DETAIL_URL } from 'constants'

import { MAKER_TYPE, BRAND_TYPE, MODEL_TYPE } from 'components/AddItemModal/constants'


import './style.scss'


export class VehicleDataStep extends BasePureComponent {
  constructor(props) {
    super(props)

    this.state = {
      errors: {},
      canCreateMaker: false,
      newMakerLabel: '',
      inputProps: {
        disabled: false
      }
    }
    this._bind('_openAddMakerModal', '_openAddBrandModal', '_openAddModelBrand', '_openAddModal',
               '_onSubmit', '_onChange', '_onSelectChange',
               '_onCreateMaker', '_onCreateBrand', '_onCreateModel',
               '_fetchMakers', '_fetchBrands', '_fetchModels')
  }

  /**
  * Generic func to open showSecondModal with passed config
  * so we avoid duplicated code.
  **/
  _openAddModal(config) {
    if (config.shouldOpen) {
      const Modal = (
        <AddItemModal
          itemType={config.type}
          itemName={config.name}
          onConfirm={config.onConfirm} />
      )
      this.context.showSecondModal(Modal, {onClose: config.onCancel})
    }
  }

  _openAddMakerModal(e) {
    e.preventDefault()

    this._openAddModal({
      type: MAKER_TYPE,
      shouldOpen: this.state.canCreateMaker,
      name: this.state.newMakerLabel,
      onConfirm: this._onCreateMaker,
      onCancel: () => this.setState({ canCreateMaker: false, newMakerLabel: '' })
    })
  }

  _openAddBrandModal(e) {
    e.preventDefault()

    this._openAddModal({
      type: BRAND_TYPE,
      shouldOpen: this.state.canCreateBrand && !!this.state.newBrandLabel,
      name: this.state.newBrandLabel,
      onConfirm: this._onCreateBrand,
      onCancel: () => this.setState({ canCreateBrand: false, newBrandLabel: '' }),
    })
  }

  _openAddModelBrand(e) {
    e.preventDefault()

    this._openAddModal({
      type: MODEL_TYPE,
      shouldOpen: this.state.canCreateModel && !!this.state.newModelLabel,
      name: this.state.newModelLabel,
      onConfirm: this._onCreateModel,
      onCancel: () => this.setState({ canCreateModel: false, newModelLabel: '' }),
    })
  }

  async _onSubmit(e) {
    e.preventDefault()
    this.setState({ inputProps: { disabled: true }})

    const method = !!this.props.vehicleId ? 'PUT' : 'POST'
    const URL = !!this.props.vehicleId ? VEHICLE_DETAIL_URL(this.props.clientId, this.props.vehicleId) : CLIENT_VEHICLES_URL(this.props.clientId)
    await request(URL, {
      method: method,
      body: {...this.props.data}
    })
    .then(({vehicle}) => {
      request(VEHICLES_LIST_URL(this.props.clientId))
      .then(({ vehicles }) => {
        this.props.vehiclesFetched(vehicles)
      })
      .catch(console.error)
      this.props.updateId(vehicle.id)
      this.props.nextStep()
    })
    .catch(({response}) => {
      const errors = !!response && !!response.fields ? {...response.fields} : {}
      this.setState({ errors, inputProps: { disabled: false }})
    })
  }

  _onChange(e) {
    this.props.updateDatasetValue(e.target.name, e.target.value)
  }

  _onSelectChange(name, selectedOption) {
    const selectedValue = selectedOption ? selectedOption.value : null
    this.props.updateDatasetValue(name, selectedValue)
  }

  _onCreateMaker(name) {
    request(MAKERS_URL, {
      method: 'POST',
      body: { name }
    })
    .then(({maker}) => {
      this.props.updateDatasetValue('maker', maker.id)
      // force update of Select.options with current label
      // this will automatically put created value as selected
      this.makerSelect.select.loadOptions(name)
    })
    .catch(console.log)
  }

  _onCreateBrand(name) {
    request(BRANDS_URL, {
      method: 'POST',
      body: {
        name,
        maker: this.props.data.maker
      }
    })
    .then(({brand}) => {
      this.props.updateDatasetValue('brand', brand.id)
      // force update of Select.options with current label
      // this will automatically put created value as selected
      this.brandSelect.select.loadOptions(name)
    })
    .catch(console.log)
  }

  _onCreateModel(name) {
    request(MODELS_URL, {
      method: 'POST',
      body: {
        name,
        brand: this.props.data.brand,
        maker: this.props.data.maker,
      }
    })
    .then(({model}) => {
      this.props.updateDatasetValue('model', model.id)
      // force update of Select.options with current label
      // this will automatically put created value as selected
      this.modelSelect.select.loadOptions(name)
    })
    .catch(console.log)
  }

  /*
  * Resets dependent Selects
  * this needs to be executed after maker or brand change
  * gets reflected on reducer-state i.e when component was updated
  */
  componentDidUpdate(prevProps) {
    //
    if ( prevProps.data.maker !== this.props.data.maker ) {
      // update dependent selects' options
      this.props.updateDatasetValue('brand', null)
      this.props.updateDatasetValue('model', null)

      // reload makers if was set to null
      !this.props.data.maker && this.makerSelect.select.loadOptions('')

      !!this.brandSelect && this.brandSelect.select.loadOptions('')
      !!this.modelSelect && this.modelSelect.select.loadOptions('')
    }

    if ( prevProps.data.brand !== this.props.data.brand ) {
      this.props.updateDatasetValue('model', null)
      !!this.modelSelect && this.modelSelect.select.loadOptions('')
    }
  }

  _fetchMakers(value) {
    return request(`${MAKERS_URL}?q=${value}`)
      .then((response) => {
        var index = response.makers.map(function(item) { return item.name; }).indexOf("Otro")
        if (index >= 0) { response.makers.splice(index, 1) }
        const options = response.makers.map((item) => ( { value: item.id, label: item.name } ))
        this.setState({ newMakerLabel: value, canCreateMaker: !options.length })
        return { options }
      })
  }

  _fetchBrands(value) {
    return request(`${BRANDS_URL}?q=${value}&m=${this.props.data.maker}`)
      .then((response) => {
        var index = response.brands.map(function(item) { return item.name; }).indexOf("Otro")
        if (index >= 0) { response.brands.splice(index, 1) }
        const options = response.brands.map((item) => ( { value: item.id, label: item.name } ))
        this.setState({ newBrandLabel: value, canCreateBrand: !options.length })
        return { options }
      })
  }

  _fetchModels(value) {
    return request(`${MODELS_URL}?q=${value}&m=${this.props.data.maker}&b=${this.props.data.brand}`)
      .then((response) => {
        var index = response.models.map(function(item) { return item.name; }).indexOf("Otro")
        if (index >= 0) { response.models.splice(index, 1) }
        const options = response.models.map((item) => ( { value: item.id, label: item.name } ))
        this.setState({ newModelLabel: value, canCreateModel: !options.length })
        return { options }
      })
  }

  render() {
    return (
      <div className="VehicleDataStep">
        <div className="VehicleDataStep__left">
          <div className="d-flex VehicleDataStep__select first">
              <Select
                cache={false}
                errors={this.state.errors.maker}
                label="Marca"
                loadingPlaceholder="Buscando..."
                loadOptions={this._fetchMakers}
                onChange={(selectedOption) => this._onSelectChange('maker', selectedOption)}
                placeholder=""
                ref={(select) => this.makerSelect = select}
                searchPromptText=""
                value={this.props.data.maker}
                {...this.state.inputProps}
              />
            {

            <button className="VehicleDataStep__add-btn" onClick={this._openAddMakerModal}>
              <i className="material-icons">add</i>
            </button>

            }
          </div>
          {
            this.props.data.maker ? (
              <div className="d-flex VehicleDataStep__select second">
                  <Select
                    cache={false}
                    errors={this.state.errors.brand}
                    label="Línea"
                    loadingPlaceholder="Buscando..."
                    loadOptions={this._fetchBrands}
                    onChange={(selectedOption) => this._onSelectChange('brand', selectedOption)}
                    placeholder=""
                    ref={(select) => this.brandSelect = select}
                    searchPromptText=""
                    value={this.props.data.brand}
                    {...this.state.inputProps}
                  />
                  <button className="VehicleDataStep__add-btn" onClick={this._openAddBrandModal}>
                    <i className="material-icons">add</i>
                  </button>
              </div>
            ) : null
          }
          {
            this.props.data.brand ? (
              <div className="d-flex VehicleDataStep__select third">
                  <Select
                    cache={false}
                    errors={this.state.errors.model}
                    label="Modelo"
                    loadingPlaceholder="Buscando..."
                    loadOptions={this._fetchModels}
                    noResultsText='Sin resultados - Da clic en el "+" para agregar marca'
                    onChange={(selectedOption) => this._onSelectChange('model', selectedOption)}
                    placeholder=""
                    ref={(select) => this.modelSelect = select}
                    searchPromptText=""
                    value={this.props.data.model}
                    {...this.state.inputProps}
                  />

                  <button className="VehicleDataStep__add-btn" onClick={this._openAddModelBrand}>
                    <i className="material-icons">add</i>
                  </button>
              </div>
            ) : null
          }
        </div>
        <div className="VehicleDataStep__separator"></div>
        <div className="VehicleDataStep__right">
          <Input
            label="Número de motor"
            onChange={this._onChange}
            name="engine_id"
            value={this.props.data.engine_id}
            errors={this.state.errors.engine_id}
            placeholder="XXXXXXXXXXXX"
            {...this.state.inputProps}
          />
          <Input
            label="Número de serie del coche"
            onChange={this._onChange}
            name="serial_number"
            value={this.props.data.serial_number}
            errors={this.state.errors.serial_number}
            placeholder="XXXXXXXXXXXX"
            {...this.state.inputProps}
          />
          <Input
            label="Placas"
            onChange={this._onChange}
            name="plates"
            value={this.props.data.plates}
            errors={this.state.errors.plates}
            placeholder="XXXXXXXXXXXX"
            {...this.state.inputProps}
          />
          <Input
            label="Alias"
            onChange={this._onChange}
            name="alias"
            value={this.props.data.alias}
            errors={this.state.errors.alias}
            placeholder="XXXXXXXXXXXX"
            {...this.state.inputProps}
          />
          <Button onClick={this._onSubmit} {...this.state.inputProps}>Continuar</Button>
        </div>
      </div>
    )
  }
}


VehicleDataStep.contextTypes = {
  showSecondModal: PropTypes.func.isRequired
}


const mapStateToProps = (state) => {
  return {
    currentStep: state.addVehicleModal.get('currentStep'),
    // this will be populated after creating vehicle in this step
    vehicleId: state.addVehicleModal.get('vehicleId'),
    data: state.addVehicleModal.get(VEHICLE_DATASET).toJS()
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    nextStep: () => dispatch(nextStep()),
    updateId: (id) => dispatch(updateId('vehicleId', id)),
    vehiclesFetched: (vehicles) => dispatch(vehiclesFetched(vehicles)),
    updateDatasetValue: (name, value) => dispatch(updateDatasetValue(VEHICLE_DATASET, name, value)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleDataStep)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/AddVehicleModal/VehicleDataStep/index.js